var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoubleArrowSprint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 171.297,
    height: 171.287,
    viewBox: "0 0 171.297 171.287",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_5151",
    "data-name": "Ret\\xE2ngulo 5151",
    width: 171.297,
    height: 171.287,
    transform: "translate(-5 -5)",
    fill: "rgba(255,255,255,0.4)",
    stroke: "#fff",
    strokeWidth: 3
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9840",
    "data-name": "Grupo 9840",
    transform: "translate(5 5)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5565",
    "data-name": "Caminho 5565",
    d: "M146.365,82.22c-.694,4.256-3.249,7.331-6.2,10.276q-32.128,32-64.153,64.108c-3.8,3.8-8.266,5.616-13.573,4.207-10.487-2.786-13.667-15.027-6.011-22.935,3.322-3.431,6.745-6.763,10.124-10.139q22.883-22.877,45.774-45.745a13.124,13.124,0,0,1,1.479-1.1c-.68-.715-1.094-1.17-1.53-1.606Q84.551,51.559,56.822,23.841C53.476,20.5,51.684,16.6,52.334,11.8A13.456,13.456,0,0,1,63.08.287c.355-.075.7-.19,1.052-.287h3.151c4.193.7,7.261,3.175,10.175,6.1q31.288,31.408,62.7,62.692c2.955,2.944,5.526,6.011,6.207,10.277Z",
    transform: "translate(14.932)",
    fill: "rgba(255,255,255,0.4)",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5566",
    "data-name": "Caminho 5566",
    d: "M48.017,77.607A14.823,14.823,0,0,1,46.2,76.314Q25.406,55.468,4.631,34.6C.791,30.749-.9,26.218.493,20.852a12.984,12.984,0,0,1,10.263-9.958c5.256-1.195,9.763.482,13.346,4.449Q41.565,34.682,58.964,54.081,68.021,64.147,77.089,74.2A19.047,19.047,0,0,1,78.366,75.8c2.564,3.543,2.472,6.662-.31,10.02-.635.767-1.305,1.509-2.009,2.215q-25.941,26.055-51.891,52.1c-3.28,3.295-7.082,5.071-11.845,4.653A13.729,13.729,0,0,1,.46,127.75a16.048,16.048,0,0,1,4.382-7.143q20.736-20.8,41.47-41.594c.4-.4.876-.727,1.705-1.406",
    transform: "translate(0 3.008)",
    fill: "rgba(255,255,255,0.4)",
    stroke: "#fff",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowSprint);
export default __webpack_public_path__ + "static/media/DoubleArrowSprint.b0d6b3b56af1dc05bae2838e2f0d8316.svg";
export { ForwardRef as ReactComponent };